import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_location",
  "use": "icon-control_location-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_location\"><g transform=\"translate(2 2)\" stroke=\"currentColor\" fill=\"transparent\"><circle cx=\"6\" cy=\"6\" r=\"4.5\" /><circle cx=\"6\" cy=\"6\" r=\"1\" /><path stroke-linecap=\"round\" d=\"M6 1.195V0M6 12v-1.286M1.292 6H0M10.62 6H12\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol